import { api } from "@/lib/api";

export const sendContact = (form, app) => api.post("/contact", { ...form, app });

export const contactErr = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return "Please check your name, email and message (at least 5 characters).";
  return d || "Could not send. Please try again.";
};
